import type { Invoice } from '../types/subscriptionManagement'
import { getFxRates, toInr } from './fxUtils'

/** Sum invoice amounts, converted into the subscription billing currency. */
export function totalSpentInSubscriptionCurrency(
  invoices: Invoice[],
  subCurrency: string,
): number {
  if (!invoices.length) return 0
  const rates = getFxRates()
  const ccy = (subCurrency || 'USD').toUpperCase()
  const totalInr = invoices.reduce(
    (s, i) =>
      s +
      toInr(Number(i.amount) || 0, i.currency || 'USD', {
        invoiceDate: i.invoiceDate,
      }),
    0,
  )
  const rate = rates[ccy] ?? 1
  return ccy === 'INR' ? totalInr : totalInr / rate
}

/** Mean invoice amount in subscription currency (total spent / invoice count). */
export function avgInvoiceInSubscriptionCurrency(
  invoices: Invoice[],
  subCurrency: string,
): number {
  const n = invoices.length
  if (!n) return 0
  return totalSpentInSubscriptionCurrency(invoices, subCurrency) / n
}
